module.exports = __webpack_public_path__ + "static/media/arnav_gavde.2373e6db.png";